/*import {TableSchema} from "./schema/TableSchema";

export class Schema {

    createTable(name: string): TableSchema;
    createTable(entity: Function): TableSchema;
    createTable(nameOrEntity: Function|string): TableSchema {
        return new TableSchema(nameOrEntity as string);
    }

    updateTable(table: TableSchema): Promise<void> {

    }

    dropTable(name: string): Promise<void>;
    dropTable(entity: Function): Promise<void>;
    dropTable(nameOrEntity: Function|string): Promise<void> {
    }


    hasTable(name: string): Promise<boolean>;
    hasTable(entity: Function): Promise<boolean>;
    hasTable(nameOrEntity: Function|string): Promise<boolean> {
    }

    getTables(): Promise<TableSchema[]> {

    }


    getTableNames(): Promise<string[]> {

    }

}*/